<template>
  <div>
    <base-fieldset>
      <base-input v-model.trim="userName" size="sm" label="name" clearable />
    </base-fieldset>
    <base-fieldset>
      <base-input v-model.trim="userEmail" size="sm" label="email" clearable />
    </base-fieldset>
    <base-fieldset>
      <CompanySelect :filterArray="userCompany" />
    </base-fieldset>
    <base-fieldset>
      <label class="text-xs font-semibold">{{ $t('mygwf.components.Label.status') }}</label>
      <div class="relative my-3 space-y-5 text-sm flex flex-col">
        <base-radio
          v-for="status in statusOptions"
          :key="status.label"
          :value="status.value"
          :label="status.label"
          name="status"
          v-model="userStatus"
        />
      </div>
    </base-fieldset>
  </div>
</template>

<script>
import {BaseFieldset, BaseInput, BaseRadio, BaseSelect} from '@/components/base'
import CompanySelect from '@/components/shared/CompanySelect.vue'
import _isEmpty from "lodash-es/isEmpty";

export default {
  components: {
    BaseFieldset,
    BaseInput,
    BaseRadio,
    BaseSelect,
    CompanySelect
  },
  props: {
    mobile: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      userName: this.$route.query.name || '',
      userEmail: this.$route.query.email || '',
      userStatus: this.$route.query.is_active || '',
      userType: this.$route.query.type || '',
      userCompany: this.$route.query.companies ? [...this.$route.query.companies] : [],
      statusOptions: [
        {label: 'all', value: ''},
        {label: 'active', value: 'true'},
        {label: 'inactive', value: 'false'},
      ],
      userTypeOptions: [
        {label: 'all', value: ''},
        {label: 'staff', value: 'staff'},
        {label: 'admin', value: 'admin'},
        {label: 'basic', value: 'basic'},
      ],
    }
  },
  mounted() {
    if (!this.$route.query.companies) {
      this.userCompany = []
    } else if (Array.isArray(this.$route.query.companies)) {
      this.userCompany = this.$route.query.companies.map(company => Number.parseInt(company))
    } else {
      this.userCompany.push(Number.parseInt(this.$route.query.companies))
    }
  },
  methods: {
    submit() {
      this.$store.dispatch('app/filterProp', {
        value: [this.name, this.userEmail, this.userStatus, this.userType, this.userCompany],
        name: ['name', 'email', 'is_active', 'type', 'companies'],
      })
    },
    reset() {
      this.userName = ''
      this.userEmail = ''
      this.userStatus = ''
      this.userType = ''
      this.userCompany = []
      this.$router.push({ name: 'Users', query: {} });
    },
  },
  watch: {
    $route (n, o) { if (_isEmpty(n.query)) { this.reset(); } },
    userName(n, o) {
      if (this.mobile) {
        return
      }
      this.$store.dispatch('app/filterProp', {value: n, name: 'name'})
    },
    userEmail(n, o) {
      if (this.mobile) {
        return
      }
      this.$store.dispatch('app/filterProp', {value: n, name: 'email'})
    },
    userStatus(n, o) {
      if (this.mobile) {
        return
      }
      this.$store.dispatch('app/filterProp', {value: n, name: 'is_active'})
    },
    userType(n, o) {
      if (this.mobile) {
        return
      }
      this.$store.dispatch('app/filterProp', {value: n, name: 'type'})
    },
    userCompany(n, o) {
      if (this.mobile) {
        return
      }
      this.$store.dispatch('app/filterProp', {value: n, name: 'companies'})
    },
  },
}
</script>
